
  import { storage } from "@/utils";
  let aiUrl = import.meta.env.VITE_wendaAiUrl
  let token = storage.get("token") || "";
  if (aiUrl) {
    if (token && window.location.href.indexOf("/exam-answering") == -1) {
      document.getElementById("qgxfAi").style.display = 'block';
    } else {
      document.getElementById("qgxfAi").style.display = 'none';
    }
  }

  // 显示弹窗的函数
  function showRightPopup() {
    if (!token) {
      return;
    }
    if (token.indexOf("\"") != -1) {
      token = token.replace("\"", "").replace("\"", "")
    }
    let url = aiUrl + '?qgToken=' + token;
    console.log("url:", url);
    document.getElementById('popup-iframe').src = url;
    document.getElementById('right-popup').style.display = 'block';
  }
  // 关闭弹窗
  document.getElementById('close-popup').addEventListener('click', function (e) {
    document.getElementById('right-popup').style.display = 'none';
  });

  // 拖动功能
  const popup = document.getElementById('right-popup');
  const dragbar = document.getElementById('popup-dragbar');
  let isDragging = false;
  let startX, startY, startLeft, startTop;
  dragbar.addEventListener('mousedown', function (e) {
    isDragging = true;
    startX = e.clientX;
    startY = e.clientY;
    // 只允许上下拖动和左右拖动
    startLeft = popup.offsetLeft;
    startTop = popup.offsetTop;
    document.body.style.userSelect = 'none';
  });
  document.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    let dx = e.clientX - startX;
    let dy = e.clientY - startY;
    let newLeft = startLeft + dx;
    let newTop = startTop + dy;
    // 限制弹窗不出屏幕
    newLeft = Math.min(window.innerWidth - popup.offsetWidth, Math.min(window.innerWidth - 100, newLeft));
    newTop = Math.max(0, Math.min(window.innerHeight - 100, newTop));
    console.log(newLeft, ",", newTop)
    popup.style.left = newLeft + 'px';
    popup.style.top = newTop + 'px';
    popup.style.right = 'auto'; // 解除right固定
  });
  document.addEventListener('mouseup', function () {
    isDragging = false;
    document.body.style.userSelect = '';
  });

  // 缩放功能
  const resizer = document.getElementById('popup-resizer');
  let isResizing = false;
  let startWidth, startHeight;
  resizer.addEventListener('mousedown', function (e) {
    isResizing = true;
    startX = e.clientX;
    startY = e.clientY;
    startWidth = popup.offsetWidth;
    startHeight = popup.offsetHeight;
    document.body.style.userSelect = 'none';
    e.preventDefault();
  });
  document.addEventListener('mousemove', function (e) {
    if (!isResizing) return;
    let dx = e.clientX - startX;
    let dy = e.clientY - startY;
    let newWidth = Math.max(300, startWidth + dx);
    let newHeight = Math.max(200, startHeight + dy);
    popup.style.width = newWidth + 'px';
    popup.style.height = newHeight + 'px';
  });
  document.addEventListener('mouseup', function () {
    isResizing = false;
    document.body.style.userSelect = '';
  });
  window.showRightPopup = showRightPopup;
